<section class="skills-dates-section dark">
  <div class="content">
    <p class="title">Fechas y proceso de postulación</p>
    <div class="description" #animation>
      <p>1. Completa el <a href="{{ formGenericUrl }}" class="link">formulario de postulación</a>, tienes tiempo hasta el 6 de marzo.</p>
      <p>2.	Espera la comunicación de nuestro equipo de reclutamiento para informarte sobre las fechas de nuestra sesión informativa.</p>
      <p>3. Participa de las pruebas psicométricas.</p>
      <p>4. Participa de la prueba técnica.</p>
      <p>5. Participa de la prueba de desarrollo humano.</p>
    </div>
  </div>
</section>
